import angular from 'angular';

import DashboardComponent from './dashboard.component';

const DashboardModule = angular.module('control-room.dashboard', []).component('crDashboard', DashboardComponent);

export default DashboardModule;
